<div class="pnc-detail-sticky-header">
  <span class="text-button-pipe"></span>
  <button (click)="exportPdf()"
    class="btn-text-link export-pdf-button"
    data-cy="pnc-export-pdf">
    <div class="export-pdf-button-icon iwp-icon-iwp_pdf"
    data-cy="pnc-export-pdf-icon"></div>
    {{EXPORT_BUTTON_TEXT}}
  </button>
  <span class="text-button-pipe"></span>

  @if (canMarkAsDone()) {
    <div class="pnc-done-wrapper" data-cy="pnc-done-wrapper">
      <app-switch-button
        [switchButtonConfiguration]="pncSwitchButtonConfiguration"
        [switchButtonModel]="switchButtonModel"
        (switch)="toggleDone($event)"
      data-cy="pnc-done-switch"></app-switch-button>
    </div>
    <div class="pnc-flying-menu-wrapper">
      <div class="pnc-flying-menu" data-cy="pnc-flying-menu">
        <app-tooltip [dynamic]="false" message="{{PNC_FLYING_MENU_TOOLTIP}}">
          <app-flying-menu [isDisable]="!pncIsMarked">
            <div class="pnc-sent-icon" labelFlyingMenu>
              <span class="iwp-icon-gen_user"></span>
            </div>
            <div class="pnc-sent-detail-content-wrapper" contentFlyingMenu>
              <div class="pnc-sent-detail-label"
              data-cy="pnc-sent-by-detail-label">{{PNC_MARKED_BY_LABEL}}</div>
              <div class="pnc-sent-detail-content margin-content"
              data-cy="pnc-sent-by-detail-content">{{pncDoneBy | prettyPrintUpdatedBy | undefinedValue}}</div>
              <div class="pnc-sent-detail-label"
              data-cy="pnc-sent-on-detail-label">{{PNC_MARKED_ON_LABEL}}</div>
              <div class="pnc-sent-detail-content"
              data-cy="pnc-sent-on-detail-content">{{pncDoneOn | undefinedValue}}</div>
            </div>
          </app-flying-menu>
        </app-tooltip>
      </div>
    </div>
  }
</div>
